var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ob1-linear-bar",
      attrs: { "data-ob1-component": "ProgressBar" },
    },
    [
      _c("div", { staticClass: "ob1-linear-bar-small" }, [
        _c("progress", {
          attrs: { max: _vm.totalSubSteps },
          domProps: { value: _vm.mobileCurrentSubStep },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "ob1-chevron-back-container" }, [
          _vm.currentStep > 1 || _vm.currentSubStep > 1
            ? _c("button", {
                staticClass: "ob1-link-arrow back ob1-chevron-back",
                on: { click: _vm.clickOnBackButton },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "ob1-linear-bar-label" }, [
            _vm._v(_vm._s(_vm.mobileLabel())),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "ob1-linear-bar-wide" },
        _vm._l(_vm.steps, function (step, index) {
          return _c(
            "li",
            {
              key: "step" + index,
              staticClass: "col ob1-linear-bar-item",
              attrs: {
                "aria-current": index === _vm.currentStep - 1 ? "step" : "",
                "aria-disabled": step.disabled,
              },
            },
            [
              _c("progress", {
                attrs: { max: _vm.subStepsCount(step) },
                domProps: { value: _vm.subStepIndex(step, index) },
              }),
              _vm._v(" "),
              index < _vm.currentStep - 1 && !step.disabled
                ? _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          return _vm.clickOnStep(index + 1)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "ob1-linear-bar-label" }, [
                        _vm._v(_vm._s(_vm.desktopLabel(index))),
                      ]),
                    ]
                  )
                : _c("span", { staticClass: "ob1-linear-bar-label" }, [
                    _vm._v(_vm._s(_vm.desktopLabel(index))),
                  ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }